import ShopInvoices from "../symbols/shopInvoices";

const initialState = {
  data: {
    page: 0,
    size: 10,
    total: 0,
    invoiceGroups: [],
  },
  loading: true,
  error: false,
};

function ShopInvoicesReducer(state = initialState, action: any) {
  switch (action.type) {
    case ShopInvoices.SHOP_INVOICES:
      return { ...state, loading: true, error: false };
    case ShopInvoices.SHOP_INVOICES_SUCCESS:
      return {
        ...state,
        data: {
          invoiceGroups: action.payload.Result.Page === 0
            ? action.payload.Result.InvoiceGroups
            : [...state.data.invoiceGroups, ...action.payload.Result.InvoiceGroups],
          page: action.payload.Result.Page,
          size: action.payload.Result.Size,
          total: action.payload.Result.Total,
        },
        loading: false,
        error: false,
      };
    case ShopInvoices.SHOP_INVOICES_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case ShopInvoices.CLEAR_SHOP_INVOICES:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
export default ShopInvoicesReducer;
